import { useMemo, useState } from 'react';
import { ekranKaynagi, useRaporSorgu } from '../rapor-ekrani/useRaporSorgu';
import type { PanelScreen } from '../../types/panelConfig';
import { lokasyonSecenegi, type HamLokasyonSecenegi } from './tipler';

/**
 * S349: stok raporlarının lokasyon filtresi. Seçenekler ekranın `lokasyonlar` kaynağından gelir (ds'in
 * sırasıyla). Kaynak sözlükte yoksa (eski config), ds hata verirse ya da boş dönerse `secenekler` boştur:
 * filtre çizilmez, `id` '' kalır ve listeler `@LOKASYON`suz sorgulanır. Seçim bileşen durumundadır
 * (URL'e yazılmaz); seçeneklerde olmayan seçim uygulanmaz.
 */
export function useLokasyonSecimi(screen: PanelScreen | undefined) {
  const [secilen, sec] = useState('');
  const q = useRaporSorgu<HamLokasyonSecenegi>(ekranKaynagi(screen, 'lokasyonlar'), {});
  const secenekler = useMemo(() => (q.data ?? []).map(lokasyonSecenegi), [q.data]);
  const secili = secenekler.find((l) => l.id === secilen);
  /** `id`: ds'e giden `@LOKASYON` ('' = tümü, gönderilmez). `ad`: bilgi satırı ve çekmece başlığı için. */
  return { secenekler, id: secili?.id ?? '', ad: secili?.ad ?? '', sec };
}
